var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { ELSIcon } from 'components/common';
import { KEY_CODES } from 'constants/app.constant';
export var LIST_BOX_INDEX = {
    PARENT: 0,
    DEPENDENT: 1
};
var INITIAL_OPTION_IDX = -1;
var ListBox = /** @class */ (function (_super) {
    __extends(ListBox, _super);
    function ListBox(props) {
        var _this = _super.call(this, props) || this;
        _this.getListboxId = function () { return "c-list-box-options-".concat(_this.instanceId); };
        _this.getOptionId = function (flatIdx) { return "c-list-box-option-".concat(_this.instanceId, "-").concat(flatIdx); };
        _this.toggleOptions = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState(function (prevState) { return ({
                opened: !prevState.opened,
                optionIdxSelectedByKey: INITIAL_OPTION_IDX
            }); });
        };
        _this.hideOptions = function () {
            _this.setState({
                opened: false,
                optionIdxSelectedByKey: INITIAL_OPTION_IDX
            });
        };
        _this.getFlattenedOptions = function () {
            var _a;
            var _b = _this.props, value = _b.value, hasDependent = _b.hasDependent;
            var options = _this.props.options || [];
            var flattenedOptions = options.map(function (option) { return ({ option: option, listIndex: LIST_BOX_INDEX.PARENT }); });
            if (!hasDependent) {
                return flattenedOptions;
            }
            var selectedOption = options.find(function (option) { return option.value === value; });
            var dependedOptions = (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.dependedOptions) !== null && _a !== void 0 ? _a : [];
            return flattenedOptions.concat(dependedOptions.map(function (option) { return ({ option: option, listIndex: LIST_BOX_INDEX.DEPENDENT }); }));
        };
        _this.onListBoxKeyDown = function (evt) {
            if (_this.props.disabled) {
                return;
            }
            var key = evt.keyCode;
            if (key !== KEY_CODES.TAB) {
                evt.preventDefault();
            }
            var flattenedOptions = _this.getFlattenedOptions();
            var max = flattenedOptions.length - 1;
            switch (key) {
                case KEY_CODES.ENTER: {
                    var selectedIdx = _this.state.optionIdxSelectedByKey;
                    if (selectedIdx !== INITIAL_OPTION_IDX && flattenedOptions[selectedIdx]) {
                        var _a = flattenedOptions[selectedIdx], option = _a.option, listIndex = _a.listIndex;
                        _this.props.changeHandler(option, listIndex);
                    }
                    _this.toggleOptions();
                    break;
                }
                case KEY_CODES.UP: {
                    _this.setState(function (prevState) { return ({
                        opened: true,
                        optionIdxSelectedByKey: prevState.optionIdxSelectedByKey <= 0 ? max : prevState.optionIdxSelectedByKey - 1
                    }); });
                    break;
                }
                case KEY_CODES.DOWN: {
                    _this.setState(function (prevState) { return ({
                        opened: true,
                        optionIdxSelectedByKey: prevState.optionIdxSelectedByKey >= max ? 0 : prevState.optionIdxSelectedByKey + 1
                    }); });
                    break;
                }
                case KEY_CODES.ESC: {
                    _this.hideOptions();
                    break;
                }
                default: {
                    break;
                }
            }
        };
        _this.onOptionMouseMove = function (idx) {
            _this.setState({
                optionIdxSelectedByKey: idx
            });
        };
        _this.renderList = function (options, value, listIndex) {
            var flatIdxOffset = listIndex === LIST_BOX_INDEX.DEPENDENT ? _this.props.options.length : 0;
            return (<ul className={classNames('c-list-box__options-list', { 'c-list-box__options-depended-list': listIndex === LIST_BOX_INDEX.DEPENDENT })}>
        {options.map(function (option, idx) {
                    var selected = option.value === value;
                    var flatIdx = flatIdxOffset + idx;
                    var clickHandler = function (evt) {
                        evt.stopPropagation();
                        _this.props.changeHandler(option, listIndex);
                        _this.hideOptions();
                    };
                    return (<li role="option" key={option.value} id={_this.getOptionId(flatIdx)} aria-selected={selected} className={classNames('c-list-box__options-list-item', {
                            'c-list-box__options-list-item--selected': selected,
                            'c-list-box__options-list-item--selected-by-key': _this.state.optionIdxSelectedByKey === flatIdx
                        })} onClick={clickHandler} onKeyDown={clickHandler} onMouseMove={function () {
                            _this.onOptionMouseMove(flatIdx);
                        }}>
              {option.icon && <ELSIcon customClass="u-els-margin-right-1o2" name={option.icon} size="3o4" prefix={option.iconPrefix}/>}
              <span className="c-list-box__options-list-item-text">{option.name}</span>
            </li>);
                })}
      </ul>);
        };
        _this.renderDependentList = function () {
            var _a = _this.props, options = _a.options, value = _a.value, dependedValue = _a.dependedValue, hasDependent = _a.hasDependent;
            var selectedOption = (options || []).find(function (option) { return option.value === value; });
            var dependedOptions = selectedOption ? selectedOption.dependedOptions || [] : [];
            var shouldRender = hasDependent && !!dependedOptions.length;
            if (shouldRender) {
                return _this.renderList(dependedOptions, dependedValue || dependedOptions[0].value, LIST_BOX_INDEX.DEPENDENT);
            }
            return <></>;
        };
        _this.state = {
            opened: false,
            optionIdxSelectedByKey: INITIAL_OPTION_IDX
        };
        _this.instanceId = uuidv4();
        return _this;
    }
    ListBox.prototype.render = function () {
        var _a;
        var _b = this.props, options = _b.options, value = _b.value, inline = _b.inline, disabled = _b.disabled, customClassName = _b.customClassName, ariaLabel = _b.ariaLabel;
        var _c = this.state, opened = _c.opened, optionIdxSelectedByKey = _c.optionIdxSelectedByKey;
        var selectedOption = (options || []).find(function (option) { return option.value === value; });
        var activeDescendant = opened && optionIdxSelectedByKey !== INITIAL_OPTION_IDX ? this.getOptionId(optionIdxSelectedByKey) : undefined;
        return (<div role="combobox" tabIndex={0} aria-label={ariaLabel} aria-haspopup="listbox" aria-expanded={opened} aria-controls={this.getListboxId()} aria-activedescendant={activeDescendant} className={classNames('c-list-box', (_a = {
                    'c-list-box--opened': opened,
                    'c-list-box--inline': inline,
                    'c-list-box--disabled': disabled
                },
                _a[customClassName] = !!(customClassName === null || customClassName === void 0 ? void 0 : customClassName.length),
                _a))} onClick={this.toggleOptions} onBlur={this.hideOptions} onKeyDown={this.onListBoxKeyDown}>
        <div className="c-list-box__trigger">
          <span className="o-els-flex-layout__item--grow-1 u-els-padding-right-3o4 c-list-box__display-option">{selectedOption ? selectedOption.name : ''}</span>
          <ELSIcon customClass="c-list-box__trigger-arrow" name="chevron-down"/>
        </div>

        {opened && (<div role="listbox" id={this.getListboxId()} className="c-list-box__options">
            {this.renderList(options, value, LIST_BOX_INDEX.PARENT)}
            {this.renderDependentList()}
          </div>)}
      </div>);
    };
    return ListBox;
}(Component));
export default ListBox;
